// @LTG-ID: route /
// @STATUS: BUILT
// @HERMETIC: true
// @DOCS: 07_PAGES_AND_ROUTES.md, 08_FEATURES.md (F-002..F-009)
// @CHANGED: 2026-02 session_002
// @OWNER: web
//
// Home — landing page. P1 composes the top-half sections; P2 is appending the
// bottom-half in milestones M1..M6. Snapshot landed in P2-M1 (CHG-0039).

import { useEffect } from "react";
import "../components/landing/landing-shared.css";
import Hero from "../components/landing/Hero";
import PageNav from "../components/landing/PageNav";
import TrustStrip from "../components/landing/TrustStrip";
import CitationStrip from "../components/landing/CitationStrip";
import SectorSelector from "../components/landing/SectorSelector";
import OwnerArchetype from "../components/landing/OwnerArchetype";
import DollarOfRevenue from "../components/landing/DollarOfRevenue";
import ThreePaths from "../components/landing/ThreePaths";
import Snapshot from "../components/landing/Snapshot";
import Levers from "../components/landing/Levers";
import Diagnostic from "../components/landing/Diagnostic";
import Methodology from "../components/landing/Methodology";
import SampleReport from "../components/landing/SampleReport";
import Engagements from "../components/landing/Engagements";
import Testimonials from "../components/landing/Testimonials";
// CHG-0107.2 — <RefundDisclosure /> unmounted per orchestrator ack (Option A).
// File kept on disk at ../components/landing/RefundDisclosure for reversibility.
// import RefundDisclosure from "../components/landing/RefundDisclosure";
import OwnerQuestions from "../components/landing/OwnerQuestions";
import Team from "../components/landing/Team";
import Faq from "../components/landing/Faq";
import JournalsSection from "../components/landing/JournalsSection";
import CtaStrip from "../components/landing/CtaStrip";
import AskWidget from "../components/landing/AskWidget";

export const Home = () => {
    useEffect(() => {
        document.title =
            "What is your business actually worth? · Valuation & exit planning";
    }, []);

    return (
        <div data-testid="home-landing">
            <Hero />
            <PageNav />
            <TrustStrip />
            <CitationStrip />
            <SectorSelector />
            <OwnerArchetype />
            <DollarOfRevenue />
            <ThreePaths />
            <Snapshot />
            <Levers />
            <Diagnostic />
            <Methodology />
            <SampleReport />
            <Engagements />
            <Testimonials />
            {/* <RefundDisclosure /> — unmounted CHG-0107.2 */}
            <OwnerQuestions />
            <Team />
            <Faq />
            <JournalsSection />
            <CtaStrip />
            <AskWidget />
        </div>
    );
};

export default Home;
